var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusOneDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.894 10.062H29v2.189h2.894v2.655h2.399V12.25h2.894v-2.189h-2.894v-2.64h-2.399v2.64zM41.426 7.422V16H44V5h-4.301v2.422h1.727z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.104 17.962l-.182.167-.922.832-.922-.832-.182-.167c-2.768-2.541-4.99-4.581-6.542-6.489C1.78 9.54 1 7.863 1 6.087 1 3.202 3.198 1 6.05 1c1.62 0 3.158.747 4.185 1.968l.765.91.765-.91C12.792 1.747 14.331 1 15.95 1 18.802 1 21 3.202 21 6.087c0 1.776-.78 3.452-2.354 5.386-1.552 1.908-3.774 3.948-6.542 6.49z",
    stroke: "#fff",
    strokeWidth: 2
  })));
}
export default SvgPlusOneDefault;